export const DEFAULT_PUBLIC_APP_ORIGIN = "https://muzone.co";

const isLocalHttpOrigin = (url) => {
    const hostname = url.hostname.toLowerCase();
    return url.protocol === "http:"
        && (
            hostname === "localhost"
            || hostname === "127.0.0.1"
            || hostname === "[::1]"
            || hostname === "::1"
        );
};

export const normalizeShareOrigin = (value) => {
    if (typeof value !== "string" || !value.trim()) {
        return null;
    }

    try {
        const url = new URL(value.trim());
        if (url.protocol === "https:" || isLocalHttpOrigin(url)) {
            return url.origin;
        }
    } catch (_) {
        return null;
    }

    return null;
};

export const resolveConfiguredShareOrigin = (
    specificOrigin,
    fallbackOrigin = DEFAULT_PUBLIC_APP_ORIGIN,
) => (
    normalizeShareOrigin(specificOrigin || process.env.REACT_APP_PUBLIC_APP_URL)
    || fallbackOrigin
);
